<script>
import { required } from 'vuelidate/lib/validators'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Assets from './assets'

import axios from 'axios'

export default {
	page: {
		title: 'All Assets',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Assets },
	data() {
		return {
			title: 'All Assets',
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'All Assets',
					active: true,
				},
			],
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	methods: {

	},
	computed: {

	},
	mounted () {

	},
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Assets />
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
